import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Expert {
  id: string;
  name: string;
  credentials: string;
  specialization: string;
  avatar: string;
  avatarAlt: string;
  guidesCount: number;
  rating: number;
}

interface ExpertAuthorsProps {
  experts: Expert[];
}

const ExpertAuthors = ({ experts }: ExpertAuthorsProps) => {
  return (
    <div className="bg-card rounded-xl shadow-soft p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-headline font-semibold text-foreground">Expert Authors</h3>
        <Icon name="AcademicCapIcon" size={24} variant="outline" className="text-primary" />
      </div>

      <div className="space-y-4">
        {experts.map((expert) => (
          <div
            key={expert.id}
            className="flex items-center space-x-4 p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
          >
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
              <AppImage
                src={expert.avatar}
                alt={expert.avatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1">
              <h4 className="font-semibold text-foreground mb-0.5">{expert.name}</h4>
              <p className="text-sm text-primary mb-1">{expert.credentials}</p>
              <p className="text-xs text-muted-foreground">{expert.specialization}</p>
              <div className="flex items-center space-x-4 mt-2">
                <div className="flex items-center space-x-1">
                  <Icon name="DocumentTextIcon" size={14} variant="outline" className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{expert.guidesCount} guides</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="StarIcon" size={14} variant="solid" className="text-warning" />
                  <span className="text-xs font-semibold text-foreground">{expert.rating}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpertAuthors;